import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Fragment } from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import moment from 'moment';

export const AccionesVisita = ({ historial }) => {

    return (<Timeline className="lineTime">
        {(historial.length > 0) && historial.map((evento, index) => {
            const isLast = index === historial.length - 1;
            return <Fragment key={`id-historial-index-${index}`}>
                <TimelineItem >
                    <TimelineOppositeContent className="leftContent">
                        <span className="date">
                            <CalendarTodayIcon className="iconCalendar" />
                            <div className='fecha-realizacion'>{!!evento.fecha ? moment(evento.fecha).format("DD/MM/YYYY HH:mm") : '-'}</div>
                        </span>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineDot sx={{
                            width: '4px',
                            height: '4px',
                            bgcolor: '#0063BE',
                            border: '3px solid #B9D1EB',
                            borderRadius: '50%'
                        }} />
                        {!isLast && <TimelineConnector sx={{ bgcolor: '#B9D1EB', border: '3px' }} />}
                    </TimelineSeparator>
                    <TimelineContent className="rightContent">
                        <Accordion className='card-contenido-detalle' defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ArrowDropDownIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <div className="titulo-evento-historial"><strong>{evento?.accion} </strong></div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="estadoHistorial"><strong>Usuario: </strong><span style={{ marginLeft: 5 }}>{evento.usuario}</span></div>
                                {!!evento.justificacion && <div className="estadoHistorial" style={{ display: 'table-cell', verticalAlign: 'top' }}><strong>Justificación: </strong><label className='motivo-rechazo-descripcion' style={{ marginLeft: 5 }}>{evento.justificacion}</label></div>}
                            </AccordionDetails>
                        </Accordion>
                    </TimelineContent>
                </TimelineItem>
            </Fragment>
        })
        }
    </Timeline>);
}